import {Checkbox, Stack} from '@chakra-ui/react';
import {
  Box,
  Button,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  useDisclosure,
  Modal,
  Flex,
  Spinner,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
  IconButton,
} from '@chakra-ui/react';
import { FaEye } from 'react-icons/fa';
import React, {useEffect, useState, useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import BoxCard from '../General/BoxCard';
import {CustomCheckbox, CustomInput} from '../General/FormInputs';
import {queryStringBuilder, getFile, postDelete, get, post} from '../../service/ApiService';
import {Report, Survey, SMaster} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';
import ServiceTypes from '../../constants/ServiceTypes';
import {EMAIL_CATEGORIES} from '../Maintenance/Clients/Emails';

const svtKeysWithPrint = ['Funeral', 'Cremation'];

const DELETE_ROUTES = {
  [ServiceTypes.FUNERAL]: Survey.DELETE_FUNERAL,
  [ServiceTypes.CREMATION]: Survey.DELETE_CREMATION,
  [ServiceTypes.CEMETARY]: Survey.DELETE_CEMETARY,
  [ServiceTypes.MONUMENT]: Survey.DELETE_MONUMENT,
  [ServiceTypes.PRE_NEED]: Survey.DELETE_PRE_NEED,
  [ServiceTypes.PET_CREMATION]: Survey.DELETE_PET_CREMATION,
  [ServiceTypes.EVENT_PLANNING]: Survey.DELETE_EVENT_PLANNING,
};

// includes={{chinese:true, surveyFormat:true, recommendations:true}} whether to show these elements
const SurveySideBar = ({control, includes, data, register, getValues, reset, errors, svcType, sMasterId, isSaving, setData}) => {
  const [pdfUrl, setPdfUrl] = useState('');
  const [toast, setToast] = useState('');
  const [isLoadingReport, setIsLoadingReport] = useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const {isOpen, onOpen, onClose} = useDisclosure();
  const {isOpen: isEmailOpen, onOpen: onEmailOpen, onClose: onEmailClose} = useDisclosure();
  const {isOpen: isConfirmOpen, onOpen: onConfirmOpen, onClose: onConfirmClose} = useDisclosure();
  const {isOpen: isDateEmailOpen, onOpen: onDateEmailOpen, onClose: onDateEmailClose} = useDisclosure();
  const navigate = useNavigate();
  const [surveyStatus, setSurveyStatus] = useState('');
  const radios = [
    {key: 'Positive Survey', id: 'svPos', value: '1'},
    {key: 'Needs Attention', id: 'svNeedatt', value: '0'},
    {key: 'Negative Survey', id: 'svNeg', value: '-1'},
  ];
  const isMounted = useRef(false);
  const linkRef = useRef(null);
  const [clientId, setClientId] = useState(null);
  const [selectedEmailCategory, setSelectedEmailCategory] = useState('');
  const [emailContacts, setEmailContacts] = useState([]);
  const [isLoadingEmails, setIsLoadingEmails] = useState(false);
  const [dateEmailLogs, setDateEmailLogs] = useState([]);
  const [isLoadingDateEmails, setIsLoadingDateEmails] = useState(false);

  const OnDateReceivedChange = e => {
    localStorage.setItem('prevDateAdded', e.target.value);
  };

  useEffect(() => {
    if (data.svPos) {
      setSurveyStatus('1');
    } else if (data.svNeg) {
      setSurveyStatus('-1');
    } else if (data.svNeedatt) {
      setSurveyStatus('0');
    } else {
      setSurveyStatus('');
    }
  }, [data]);

  useEffect(() => {
    if (surveyStatus === '1') {
      data.svPos = true;
      data.svNeg = false;
      data.svNeedatt = false;
    } else if (surveyStatus === '0') {
      data.svPos = false;
      data.svNeg = false;
      data.svNeedatt = true;
    } else if (surveyStatus === '-1') {
      data.svPos = false;
      data.svNeg = true;
      data.svNeedatt = false;
    } else {
      data.svPos = false;
      data.svNeg = false;
      data.svNeedatt = false;
    }
  }, [surveyStatus]);


  const recsLeft = [
    {name: 'Family Member', id: 'svAdv1'},
    {name: 'Friend', id: 'svAdv2'},
    {name: 'Neighbor', id: 'svAdv3'},
    {name: 'Associate/Colleague', id: 'svAdv4'},
    {name: 'Clergy or Religious', id: 'svAdv5'},
    {name: 'Hospice', id: 'svAdv6'},
    {name: 'Social Worker', id: 'svAdv7'},
    {name: 'Hospital', id: 'svAdv8'},
    {name: 'Nursing Home', id: 'svAdv9'},
    {name: 'Law Enforcement', id: 'svAdv10'},
    {name: 'Health Care Provider', id: 'svAdv11'},
  ];

  const recsRight = [
    {name: 'Lawyer', id: 'svAdv12'},
    {name: 'Named Individual Unknown Source', id: 'svAdv13'},
    {name: 'Known Owner/Employee', id: 'svAdv15'},
    {name: 'Other Funeral Home', id: 'svAdv16'},
    {name: 'Doctor/Nurse', id: 'svAdv17'},
    {name: 'Assisted Living', id: 'svAdv18'},
    {name: 'Elderly Housing', id: 'svAdv19'},
    {name: 'Coroner/Medical Examiner', id: 'svAdv20'},
    {name: 'Deceased', id: 'svAdv21'},
    {name: 'Other', id: 'svAdv14'},
  ];

  const ElevatedSurface = props => {
    return (
      <Box boxShadow="sm" rounded="md" borderColor={'blackAlpha.200'} borderWidth="1px" {...props} textAlign="start" pl="9">
        {props.children}
      </Box>
    );
  };

  const printSurvey = async () => {
    const fileNames = {
      Funeral: 'surveyrpt_f.rdlx',
      Cremation: 'surveyrpt_c.rdlx',
    };

    const fileName = fileNames[svcType?.key];
    if (!fileName) return;

    const params = {
      sMasterId,
    };

    const url = queryStringBuilder(`${Report.GET_SURVEY}/${fileName}`, params);

    setIsLoadingReport(true);

    const response = await getFile(url);

    if (isMounted.current === false) return;

    setIsLoadingReport(false);

    if (response.error) {
      setToast({response: {error: 1}, errorMessage: 'Error getting report: ' + response.error});
      return;
    }

    const fileURL = window.URL.createObjectURL(response);

    if (!response.error) {
      setPdfUrl(fileURL);
    }
  };

  const loadClientId = async () => {
    console.log('[DateSurveyEmail] loadClientId start', { sMasterId });
    if (!sMasterId) return null;
    const resp = await get(SMaster.RECORD + '/' + sMasterId);
    console.log('[DateSurveyEmail] /SMaster response', resp);
    if (resp?.error) {
      console.warn('[DateSurveyEmail] error in /SMaster response');
      return null;
    }

    const candidateFields = ['nclientpk', 'smClient', 'clientId'];
    let pickedField = null;
    let pickedValue = null;

    for (const field of candidateFields) {
      const value = resp?.[field];
      const parsed = parseInt(value, 10);
      if (!Number.isNaN(parsed) && parsed > 0) {
        pickedField = field;
        pickedValue = parsed;
        break;
      }
    }

    console.log('[DateSurveyEmail] clientId resolution', { pickedField, pickedValue });

    if (pickedValue) {
      setClientId(pickedValue);
      return pickedValue;
    }

    console.warn('[DateSurveyEmail] No numeric client id found in /SMaster response');
    return null;
  };

  const fetchClientEmails = async (category, ensureClientId = null) => {
    const clIdToUse = ensureClientId ?? clientId ?? (await loadClientId());
    if (!clIdToUse || !category) return;
    setIsLoadingEmails(true);
    const route = `/clientemail/list?page=1&pageSize=100&clId=${clIdToUse}&category=${encodeURIComponent(category)}`;
    const response = await get(route);
    if (!response?.error && response?.isSuccess) {
      setEmailContacts(response.data || []);
    } else {
      setEmailContacts([]);
    }
    setIsLoadingEmails(false);
  };

  const sendCategoryEmail = async () => {
    if (!selectedEmailCategory || emailContacts.length === 0) return;
    
    const selectedCategory = EMAIL_CATEGORIES.find(cat => cat.value === selectedEmailCategory);
    const reportName = selectedCategory?.report || '';
    
    const payload = {
      clId: clientId,
      emailSubject: selectedCategory?.subject || "Survey Report",
      emailFrom: "survey@fsrgsurvey.com",
      items: emailContacts.map(contact => ({
        category: selectedEmailCategory,
        name: contact.name,
        email: contact.email,
        description: "",
        url: "",
        surveyDate: getValues?.('dateAdded') || '',
        reportName: reportName,
        attachmentPath: "",
        svRecord: data.svRecord || data.smRecord
      }))
    };

    try {
      const response = await post('/clientemaillog/bulk-add-simple', payload);
      if (response?.isSuccess) {
        setToast({response: response, successMessage: 'Emails queued successfully'});
      } else {
        setToast({response: response, errorMessage: response?.error || 'Failed to queue emails'});
      }
    } catch (error) {
      setToast({response: {error: 1}, errorMessage: 'Error sending emails: ' + error.message});
    }
    
    onConfirmClose();
    onEmailClose();
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const formatDateWithWeekday = (dateString) => {
    if (!dateString) return '';
    const d = new Date(dateString);
    const parts = new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).formatToParts(d);
    const map = Object.fromEntries(parts.map(p => [p.type, p.value]));
    // Compose as: Tue Sep 30, 2025 (no comma after weekday)
    return `${map.weekday} ${map.month} ${map.day}, ${map.year}`;
  };

  const formatDateTimeWithWeekday = (dateString) => {
    if (!dateString) return '';
    const d = new Date(dateString);
    const parts = new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).formatToParts(d);
    const map = Object.fromEntries(parts.map(p => [p.type, p.value]));
    // Compose as: Tue Sep 30, 2025 3:53 pm
    return `${map.weekday} ${map.month} ${map.day}, ${map.year} ${map.hour}:${map.minute} ${map.dayPeriod}`;
  };

  const viewEmailReport = async (row) => {
    if (!data.svRecord || !row.surveyDate) {
      console.warn('[viewEmailReport] Missing required data:', { svRecord: data.svRecord, surveyDate: row.surveyDate });
      return;
    }
    
    // Load client ID from SMaster record
    let smClient = data.smClient;
    if (!smClient && sMasterId) {
      const resp = await get(SMaster.RECORD + '/' + sMasterId);
      if (!resp?.error && resp?.smClient) {
        smClient = resp.smClient;
      }
    }
    
    if (!smClient) {
      console.warn('[viewEmailReport] Could not resolve smClient');
      setToast({response: {error: 1}, errorMessage: 'Could not resolve client ID for report'});
      return;
    }
    
    const startDate = row.surveyDate.split('T')[0]; // Get YYYY-MM-DD format
    const endDate = startDate; // Same date for start and end
    
    const url = `/report/survey2-email?cl_id=${smClient}&startdate=${startDate}&enddate=${endDate}&sv_record=${data.svRecord}`;
    console.log('[viewEmailReport] Requesting URL:', url);
    
    try {
      const response = await getFile(url);
      console.log('[viewEmailReport] Response:', response);
      
      if (response.error) {
        setToast({response: {error: 1}, errorMessage: 'Error getting report: ' + response.error});
        return;
      }
      
      const fileURL = window.URL.createObjectURL(response);
      console.log('[viewEmailReport] Created blob URL:', fileURL);
      
      // Try multiple approaches to open the PDF
      const newWindow = window.open(fileURL, '_blank');
      if (!newWindow) {
        // Fallback: create a temporary link and click it
        const link = document.createElement('a');
        link.href = fileURL;
        link.target = '_blank';
        link.download = 'survey-report.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      
      // Clean up the blob URL after a delay
      setTimeout(() => {
        window.URL.revokeObjectURL(fileURL);
      }, 1000);
      
    } catch (error) {
      console.error('[viewEmailReport] Error:', error);
      setToast({response: {error: 1}, errorMessage: 'Error opening report: ' + error.message});
    }
  };

  const fetchDateSurveyEmails = async () => {
    if (!data.svRecord) {
      console.warn('[DateSurveyEmail] svRecord not available in data');
      return;
    }
    setIsLoadingDateEmails(true);
    const route = `/clientemaillog/list?page=1&pageSize=100&svRecord=${data.svRecord}`;
    console.log('[DateSurveyEmail] GET route', route);
    const response = await get(route);
    console.log('[DateSurveyEmail] /clientemaillog/list response', response);
    if (!response?.error && response?.isSuccess) {
      const sorted = (response.data || []).slice().sort((a, b) => {
        const aDate = a?.surveyDate ? new Date(a.surveyDate).getTime() : 0;
        const bDate = b?.surveyDate ? new Date(b.surveyDate).getTime() : 0;
        if (aDate !== bDate) return bDate - aDate; // date desc
        const aName = a?.name || '';
        const bName = b?.name || '';
        return aName.localeCompare(bName); // name asc
      });
      setDateEmailLogs(sorted);
    } else {
      console.warn('[DateSurveyEmail] error or !isSuccess from /clientemaillog/list', response);
      setDateEmailLogs([]);
    }
    setIsLoadingDateEmails(false);
  };

  const exportDateEmailsCsv = () => {
    const headers = ['Category', 'Name', 'Email', 'Survey Date', 'Email At', 'svRecord', 'clId'];
    const escapeCsv = value => {
      const s = value == null ? '' : String(value);
      if (/[",\n]/.test(s)) {
        return '"' + s.replace(/"/g, '""') + '"';
      }
      return s;
    };
    const rows = dateEmailLogs.map(row => [
      escapeCsv(row.category),
      escapeCsv(row.name),
      escapeCsv(row.email),
      escapeCsv(formatDateWithWeekday(row.surveyDate)),
      escapeCsv(formatDateTimeWithWeekday(row.createdAt)),
      escapeCsv(data.svRecord),
      escapeCsv(data.smClient || row.clId),
    ]);
    const csv = [headers.join(','), ...rows.map(r => r.join(','))].join('\r\n');
    const blob = new Blob(['\ufeff' + csv], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'date-survey-emails.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleImport = async () => {
    setIsImporting(true);
    // const response = await new Promise(resolve => setTimeout(resolve, 1000));
    const response = await get('/Survey/get-online-data/' + sMasterId);
    if (isMounted.current === false) return;

    response.isOnlineSurveyAvailable = true;
    response.dateAdded = response.dateAdded.split('T')[0];

    reset(response);

    setIsImporting(false);
    setToast({response, successMessage: 'Survey Imported Successfully'});
  };

  const handleDelete = async () => {
    if (!data.id) {
      setToast({response: {error: 1}, errorMessage: 'No Survey Found'});
      return;
    }

    setIsDeleting(true);
    const deleteResponse = await postDelete(DELETE_ROUTES[svcType?.value] + '/' + data.id);
    if (isMounted.current === false) return;

    setIsDeleting(false);
    setToast({response: deleteResponse, successMessage: 'Survey Deleted With Record Number ' + data.svRecord});

    if (!deleteResponse.error) {
      navigate('/surveys/lookup', {state: {serviceType: svcType}});
    }
  };

  const doneFunction = () => {
    onClose();
  };

  useEffect(() => {
    if (pdfUrl.length > 0) linkRef.current.click();
  }, [pdfUrl]);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <BoxCard>
      <a href={pdfUrl} target="_blank" rel="noopener noreferrer" ref={linkRef} style={{display: 'none'}} />
      <ElevatedSurface>
        {radios.map((item, idx) => {
          return (
            <Checkbox
              colorScheme={'tertiary'}
              onChange={e => {
                if (e.target.checked) {
                  setSurveyStatus(item.value);
                } else {
                  setSurveyStatus('');
                }
              }}
              isChecked={surveyStatus === item.value}
              ml="2"
              key={idx}
            >
              {item.key}
            </Checkbox>
          );
        })}

        {includes.chinese && <CustomCheckbox control={control} name="Chinese Survey" id="svChinese" defaultChecked={data.svChinese} ml="2" />}
        {includes.surveyFormat && (
          <>
            <CustomCheckbox control={control} name="Electronic Survey" id="svEsurvey" defaultChecked={data.svEsurvey} ml="2" />
            <CustomCheckbox control={control} name="Received Via Email" id="svEmail" defaultChecked={data.svEmail} ml="2" />
            <CustomCheckbox control={control} name="Received Via Text" id="svText" defaultChecked={data.svText} ml="2" />
          </>
        )}
      </ElevatedSurface>

      <ElevatedSurface my="4">
        <Box my="3" mr="4" alignItems={'center'}>
          <CustomInput id="dateAdded" name="Date Survey Received" register={register} errors={errors} type={'date'} onChange={OnDateReceivedChange} />
        </Box>
        <Button colorScheme={'secondary'} w="80%" my="3" onClick={() => { onEmailOpen(); loadClientId(); }}>
          Email Survey
        </Button>
        <Button colorScheme={'secondary'} w="80%" my="3" onClick={async () => { onDateEmailOpen(); await fetchDateSurveyEmails(); }}>
          Date Survey Email
        </Button>
      </ElevatedSurface>

      <ElevatedSurface my="4">
        <Button type="button" colorScheme={'secondary'} w="80%" my="3" onClick={onOpen}>
          Recommendation
        </Button>
      </ElevatedSurface>

      <ElevatedSurface>
        {data?.isOnlineSurveyAvailable && (
          <Button colorScheme="secondary" w="80%" my="3" onClick={handleImport} disabled={isImporting}>
            {isImporting ? <Spinner /> : 'Import'}
          </Button>
        )}
        <Button colorScheme={'secondary'} w="80%" my="3" onClick={handleDelete} disabled={isDeleting}>
          {isDeleting ? <Spinner /> : 'Delete'}
        </Button>
        <Spacer />
        <Button colorScheme={'secondary'} w="80%" my="3" onClick={() => navigate('/surveys/lookup', {state: {serviceType: svcType}})}>
          Search
        </Button>
        <Spacer />
        {/* <Button colorScheme={'secondary'} w="80%" my="3">
          Change Date
        </Button> */}
        <Button colorScheme={'secondary'} w="80%" my="3" type="submit" disabled={isSaving}>
          {isSaving ? <Spinner /> : 'Save'}
        </Button>
        {svtKeysWithPrint.includes(svcType?.key) && (
          <Button colorScheme={'secondary'} w="80%" my="3" onClick={printSurvey} disabled={isLoadingReport}>
            {isLoadingReport ? <Spinner /> : 'Print'}
          </Button>
        )}
      </ElevatedSurface>

      <Modal isOpen={isOpen} size="xl" onClose={onClose} motionPreset="slideInBottom" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Recommendation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex justifyContent="center">
              <Stack>
                {recsLeft.map(rec => {
                  return <CustomCheckbox key={rec.id} name={rec.name} id={rec.id} defaultChecked={data[rec.id]} control={control} />;
                })}
              </Stack>
              <Stack ml="4">
                {recsRight.map(rec => {
                  return <CustomCheckbox key={rec.id} name={rec.name} id={rec.id} defaultChecked={data[rec.id]} control={control} />;
                })}
              </Stack>
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="secondary" variant="outline" mr={3} onClick={() => doneFunction()}>
              Done
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isDateEmailOpen} size="6xl" onClose={onDateEmailClose} motionPreset="slideInBottom" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Date Survey Emails</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <TableContainer>
              <Table variant="striped" colorScheme="mint" size={'sm'}>
                <Thead>
                  <Tr>
                    <Th>Category</Th>
                    <Th>Name</Th>
                    <Th>Email</Th>
                    <Th>Survey Date</Th>
                    <Th>Email At</Th>
                    <Th>Action</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {isLoadingDateEmails ? (
                    <Tr>
                      <Td colSpan={6}>
                        <Flex alignItems="center" gap={2}>
                          <Spinner size="sm" />
                          <Text>Loading...</Text>
                        </Flex>
                      </Td>
                    </Tr>
                  ) : dateEmailLogs.length === 0 ? (
                    <Tr>
                      <Td colSpan={6}>
                        <Text>No records found.</Text>
                      </Td>
                    </Tr>
                  ) : (
                    dateEmailLogs.map(row => (
                      <Tr key={row.id}>
                        <Td>{row.category}</Td>
                        <Td>{row.name}</Td>
                        <Td>{row.email}</Td>
                        <Td>{formatDateWithWeekday(row.surveyDate)}</Td>
                        <Td>{formatDateTimeWithWeekday(row.createdAt)}</Td>
                        <Td>
                          <IconButton
                            aria-label="View Report"
                            icon={<FaEye />}
                            size="sm"
                            colorScheme="blue"
                            variant="ghost"
                            onClick={() => viewEmailReport(row)}
                          />
                        </Td>
                      </Tr>
                    ))
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="secondary" mr={3} onClick={exportDateEmailsCsv} disabled={dateEmailLogs.length === 0}>Export CSV</Button>
            <Button onClick={onDateEmailClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isEmailOpen} size="lg" onClose={onEmailClose} motionPreset="slideInBottom" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select Email Category</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box mb="4">
              <Select
                placeholder="Select Category"
                value={selectedEmailCategory}
                onChange={e => {
                  const cat = e.target.value;
                  setSelectedEmailCategory(cat);
                  fetchClientEmails(cat);
                }}
              >
                {EMAIL_CATEGORIES.map(c => (
                  <option key={c.value} value={c.value}>{c.label}</option>
                ))}
              </Select>
            </Box>
            <TableContainer>
              <Table variant="striped" colorScheme="mint" size={'sm'}>
                <Thead>
                  <Tr>
                    <Th>Name</Th>
                    <Th>Email</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {isLoadingEmails ? (
                    <Tr>
                      <Td colSpan={2}>
                        <Flex alignItems="center" gap={2}>
                          <Spinner size="sm" />
                          <Text>Loading...</Text>
                        </Flex>
                      </Td>
                    </Tr>
                  ) : emailContacts.length === 0 ? (
                    <Tr>
                      <Td colSpan={2}>
                        <Text>No contacts found.</Text>
                      </Td>
                    </Tr>
                  ) : (
                    emailContacts.map(row => (
                      <Tr key={row.id}>
                        <Td>{row.name}</Td>
                        <Td>{row.email}</Td>
                      </Tr>
                    ))
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="secondary"
              mr={3}
              onClick={onConfirmOpen}
              disabled={!selectedEmailCategory || emailContacts.length === 0}
            >
              Send Email
            </Button>
            <Button onClick={onEmailClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isConfirmOpen} size="md" onClose={onConfirmClose} motionPreset="slideInBottom" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm Send</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box mb="3">
              <Text>
                {selectedEmailCategory} dated. {formatDateForDisplay(getValues?.('dateAdded'))} email to
              </Text>
            </Box>
            <Box>
              {emailContacts.map(row => (
                <Text key={row.id}>{row.email}</Text>
              ))}
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="secondary" mr={3} onClick={sendCategoryEmail}>
              Confirm
            </Button>
            <Button onClick={onConfirmClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <ErrorHelper toastResponse={toast} />
    </BoxCard>
  );
};

export default SurveySideBar;
